import { FEED_ITEMS } from '@/mocks/chiliao';

export default function TodayFeed() {
  return (
    <section id="today" className="w-full scroll-mt-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        {/* 分节标题 */}
        <div className="flex flex-col gap-2 border-l-4 border-primary-500 pl-4 md:flex-row md:items-end md:justify-between md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-primary-700">
              <i className="ri-time-line text-sm" /> Today Feed
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              今日汇总 · 快讯流
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            从早间到收官，今天上了哪些料、补了哪些档，按时间一条条排给你，节奏慢一点也没关系。
          </p>
        </div>

        {/* 时间线 */}
        <div className="mt-8 border-l-2 border-background-200 pl-5 md:pl-8">
          {FEED_ITEMS.map((item) => (
            <article key={item.id} className="group relative pb-7 last:pb-0">
              {/* 时间轴节点 */}
              <span className="absolute -left-[27px] top-1 flex h-4 w-4 items-center justify-center md:-left-[41px]">
                {item.live ? (
                  <span className="relative flex h-4 w-4 items-center justify-center">
                    <span className="absolute inline-flex h-4 w-4 animate-ping rounded-full bg-accent-500/50" />
                    <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-accent-500 ring-4 ring-background-50" />
                  </span>
                ) : (
                  <span className="inline-flex h-2.5 w-2.5 rounded-full bg-secondary-300 ring-4 ring-background-50 transition-colors group-hover:bg-primary-500" />
                )}
              </span>

              <div className="flex flex-col gap-2 md:flex-row md:items-start md:gap-5">
                <div className="w-24 shrink-0">
                  <div className="flex items-center gap-2">
                    <span className="font-heading text-lg font-bold tabular-nums text-foreground-950">
                      {item.time}
                    </span>
                    {item.live && (
                      <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-semibold text-accent-800">
                        收官
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-500">{item.stage}快讯</span>
                </div>

                <div className="flex flex-1 items-start justify-between gap-4 rounded-lg bg-background-100 px-4 py-3 transition-colors hover:bg-background-200/60 md:px-5">
                  <p className="flex-1 text-sm leading-6 text-foreground-800">{item.title}</p>
                  <span className="mt-0.5 inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-chat-3-line text-sm text-accent-600" />
                    <span className="text-xs font-semibold tabular-nums text-foreground-700">
                      {item.comments}
                    </span>
                  </span>
                </div>
              </div>

              <span className="mt-2 ml-[104px] inline-flex text-xs text-foreground-500 md:ml-[136px]">
                来源 · {item.source}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}